export default function ({$axios, store, $cookies, redirect}, inject) {
  const API = $axios.create({
    baseURL: process.env.NUXT_APP_API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Accept-Language': 'en',
    }
  })

  API.onRequest(config => {
    if($cookies.get('accessToken')) {
      config.headers.common.Authorization = "Bearer " + $cookies.get('accessToken');
    }
    return config
  })

  API.onResponse(response => {
    if(response.data.code && response.data.code === 401) {
        store.dispatch('auth/setAuthentication', false);
        $cookies.remove('accessToken');
    }
    return response
  })

  API.onError(error => {
    const code = parseInt(error.response && error.response.status)
    if (code === 400 || code === 500) {
      redirect('/error-page')
    }
  })
  inject('API', API)
}
